import { useMemo, useState } from 'react';

import { useGetQueueStatusQuery } from 'services/api/products/flux';

export default function useFluxQueue() {
  const { data } = useGetQueueStatusQuery();
  const fluxQueueData = useMemo(() => {
    if (!data?.data) return [];

    return Object
      .entries(data.data)
      .map(([title, details]) => ({
        id: details.pid,
        title,
        execution: details.running ? 'Sim' : 'Não',
      }));
  }, [data]);

  const [title, setTitle] = useState<string[]>([]);
  const [execution, setExecution] = useState<string[]>([]);

  const clearFilters = () => {
    setTitle([]);
    setExecution([]);
  };

  const titleOptions = useMemo(() => (
    fluxQueueData.map((item) => item.title)
      .filter((value, index, self) => self.indexOf(value) === index)
  ), [fluxQueueData]);

  const executionOptions = useMemo(() => (
    fluxQueueData.map((item) => item.execution)
      .filter((value, index, self) => self.indexOf(value) === index)
  ), [fluxQueueData]);

  const filteredItems = useMemo(() => (
    fluxQueueData.filter((item) => (
      (title.length === 0 || title.includes(item.title))
      && (execution.length === 0 || execution.includes(item.execution))
    ))
  ), [fluxQueueData, title, execution]);

  return {
    title,
    execution,
    setTitle,
    setExecution,
    clearFilters,
    titleOptions,
    executionOptions,
    filteredItems,
  };
}
